import { createSlice } from "@reduxjs/toolkit";
import getAIStudiesApi from "@custom/rtk-apis/appointment/getAIStudies";

const initialState: any = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: ""
};

const getAIStudiesSlice: any = createSlice({
  name: "getAIStudiesSlice",
  initialState,
  reducers: {
    revertStatus(state: any) {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAIStudiesApi.pending, (state, action) => {
        state.status = "PENDING";
        state.loading = true;
      })
      .addCase(getAIStudiesApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getAIStudiesApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getAIStudiesSlice.reducer;
export const { revertStatus } = getAIStudiesSlice.actions;
